import { useThree } from '@react-three/fiber'
import { FC, useEffect } from 'react'
import { AxesHelper } from 'three'

/**
 * Component that adds axes helper to the scene for debugging orientation
 */
export const AxesHelperComponent: FC<{ size?: number }> = ({ size = 50 }) => {
  const { scene } = useThree()

  useEffect(() => {
    const axesHelper = new AxesHelper(size)
    scene.add(axesHelper)
    return () => {
      scene.remove(axesHelper)
    }
  }, [scene, size])

  return null
}
